import { Typography } from '@mui/material';
import React from 'react'
import '../../../scss/pages/MyCertificates/Training/Training.scss';
import NoRecordsFound from '../../../asset/svg/no-certificate-found.svg';
import ImageCertificate from '../../../asset/image/certificate-img.png';
import { useNavigate } from 'react-router';
import { CERTIFICATE_DOWNLOAD_PATH } from '../../../utils/Constants';
import { useSelector } from 'react-redux';


function Training() {
    const navigate = useNavigate();
    const { MyCertificateData } = useSelector(mapStateToProps)
    const handleSelectCertificateCard = (item) => {
        navigate(CERTIFICATE_DOWNLOAD_PATH, { state: { PdfUrl: item?.PdfUrl, certificateNo: item?.CertificateNumber, pageIndex: 0 } })
    }
    return (
        <div className='Training-Container'>
            <div className='Training-Container_Parent-container-grid'>
                {MyCertificateData && MyCertificateData.length > 0 ?
                    <div className='Training-Container_Parent-container-grid_cards-grid'>
                        {MyCertificateData?.map((item) => {
                            return (
                                <div key={item?.CertificateId} className='Training-Container_Parent-container-grid_cards-grid_card-Parent-Container' onClick={() => handleSelectCertificateCard(item)}>
                                    <div className='Training-Container_Parent-container-grid_cards-grid_card-Parent-Container_card-container'>
                                        <img src={item?.ThumbnailUrl} className='Training-Container_Parent-container-grid_cards-grid_card-Parent-Container_card-container_card-Image' />
                                        <Typography className='Training-Container_Parent-container-grid_cards-grid_card-Parent-Container_card-container_Name' value="name">{item?.CertificateName}</Typography>
                                    </div>
                                </div>)
                        })}
                    </div>
                    :
                    <div className='Training-Container_No-records-found'>
                        <div className='Training-Container_No-records-found_child'>
                            <img className='Training-Container_No-records-found_child_Image' src={NoRecordsFound} alt="No Records Found" />
                            <div className='Training-Container_No-records-found_child_Text-content'>
                                <Typography className='Training-Container_No-records-found_child_Text-content_Text'>No Certificate Found</Typography>
                            </div>
                        </div>
                    </div>}
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        MyCertificateData: state?.certificateConfig?.MyCertificateData,
    }
}

export default Training